import { FC } from 'react';
import { CopyButton } from '@/shared/ui';

type JsonBlockProps = {
  title: string;
  data: Record<string, unknown> | null | undefined;
  emptyLabel: string;
  copyTooltip: string;
};

// Форматированный JSON-блок
export const JsonBlock: FC<JsonBlockProps> = ({ title, data, emptyLabel, copyTooltip }) => {
  const jsonText = data && Object.keys(data).length > 0 ? JSON.stringify(data, null, 2) : '';

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-1">
        <h4 className="text-sm font-medium">{title}</h4>
        {jsonText && <CopyButton text={jsonText} tooltip={copyTooltip} />}
      </div>
      {jsonText ? (
        <pre className="text-xs bg-muted rounded-md p-3 overflow-auto max-h-64 whitespace-pre-wrap break-words">
          {jsonText}
        </pre>
      ) : (
        <p className="text-sm text-muted-foreground">{emptyLabel}</p>
      )}
    </div>
  );
};
